<!-- <alert type="info">
  <a href="https://www.boe.ca.gov/prop19/" target="_blank">
    <alert type="info">
      {{ "Prop19.Prop19Infov2" | translate }}
    </alert>

  </a>
  <p [innerHTML]="'Prop19.Prop19Info2'|translate"></p>
</alert> -->
<app-leveltwo [calculators]="true" [videos]="true" [pageName]="'Prop 19'" [news]="14">
  <div class="General">
    <h3>{{ "Prop19.PageTitle" | translate }}</h3>
    <div class="info-bar">
    <p><strong>{{'Prop19.Prop19ResidenceRequirements' | translate}}</strong></p><br>
    <!--<p>{{'Prop19.Toaddress' | translate}} {{'Prop19.TheOfficeof' | translate}}</p><br>-->

    <p [innerHTML]="'Prop19.ForTransfers' | translate"></p><br>
    <p [innerHTML]="'Prop19.ForSeniors' | translate"></p>

  </div>
    <h4>{{ "Prop19.Background" | translate }}</h4>

    <p [innerHTML]="'Prop19.BackgroundInfo092321' | translate"></p>
    <!--<p>{{'Prop19.Backgroundtext3'|translate}}</p>
      <p><b>Jeff Prang, Assessor</b></p>-->

    <h4>{{ "Prop19.WhatisProp19" | translate }}</h4>
    <h5>{{ "Prop19.Inheriting" | translate }}</h5>
    <p>{{ "Prop19.Inheritingtext" | translate }}</p>
    <h5>{{ "Prop19.Transferof" | translate }}</h5>
    <p>{{ "Prop19.Transferoftext" | translate }}</p>

    <p>
      <b>{{ "Prop19.Proposition19changes" | translate }}</b>
    </p>
    <ol>
      <li>
        {{ "Prop19.change1pt1" | translate
        }}<a
          href="https://www.boe.ca.gov/proptaxes/faqs/propositions58.htm"
          target="_blank"
          >{{ "Prop19.Prop58" | translate }}</a
        >{{ "Prop19.change1pt2" | translate
        }}<a
          href="https://www.boe.ca.gov/proptaxes/faqs/propositions58.htm"
          target="_blank"
          >{{ "Prop19.prop193" | translate }}</a
        >{{ "Prop19.change1pt3" | translate }}
      </li>
      <li>
        {{ "Prop19.change2pt1" | translate
        }}<a
          href="https://www.boe.ca.gov/proptaxes/prop60-90_55over.htm"
          target="_blank"
          >{{ "Prop19.prop6090" | translate }}</a
        >&nbsp;<a
          href="https://www.boe.ca.gov/proptaxes/disaster-relief.htm#Description"
          target="_blank"
          >{{ "Prop19.prop50171" | translate }}</a
        >{{ "Prop19.change2pt2" | translate }}
      </li>
    </ol>

    <p [innerHTML]="'Prop19.forassistancev2'|translate"></p>

    <div class="accordion">
      <accordion [isAnimated]="true">
        <accordion-group #drop>
          <div accordion-heading>
            <span class="dropdown-item clearfix">
               {{ "Prop19.Clickhere" | translate }}
              <i
                class="mt-1 float-end"
                [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
              ></i>
            </span>
          </div>
          <h4>{{ "Prop19.parent-childtransfers" | translate }}</h4>
          <table>
            <tbody>
              <tr>
                <th></th>

                <th class="header">
                <br>
                  <strong>{{ "Prop19.Prop58/193" | translate }}</strong>

                  <p>({{ "Prop19.Effectivebeforefeb" | translate }})</p>
                </th>

                <th class="header">
                <br>
                  <strong>{{ "Prop19.Prop19Caps" | translate }}</strong>

                  <p>({{ "Prop19.Effectiveasoffeb" | translate }})</p>
                </th>
              </tr>
              <tr>
                <th>{{ "Prop19.PrincipalResidence" | translate }}</th>
                <td>
                  <ul>
                    <li>{{ "Prop19.Principaloftransferor" | translate }}</li>
                    <li>{{ "Prop19.Novaluelimit" | translate }}</li>
                    <li>
                      {{ "Prop19.Residenceand" | translate }}
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>{{ "Prop19.Principaloftransferorandtransferee" | translate }}</li>
                    <li>
                      {{ "Prop19.Valuelimitcurrenttaxable" | translate }}
                    </li>
                    <li>{{ "Prop19.Familyhomes" | translate }}</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.Otherreal" | translate }}</th>
                <td>
                  {{ "Prop19.Transferorlifetime" | translate }}
                </td>
                <td>
                  {{ "Prop19.eliminatesexclusion" | translate }}
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.Grandparentgrandchildmiddlegen" | translate }}</th>
                <td colspan="2">
                  {{ "Prop19.Parentsofgrandchild" | translate }}
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.FilingPeriod" | translate }}</th>
                <td>
                  {{ "Prop19.Fileclaimwithin3years" | translate }}
                </td>
                <td>
                  {{ "Prop19.Fileforwithin1year" | translate }}
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.ImplementingStatute" | translate }}</th>
                <td>
                  {{ "Prop19.Revenue&Taxation58" | translate }}
                </td>
                <td>{{ "Prop19.Tobedetermined" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.ImportantDates" | translate }}</th>
                <td>{{ "Prop19.Throughfeb" | translate }}</td>
                <td>{{ "Prop19.Effectivefeb" | translate }}</td>
              </tr>
            </tbody>
          </table>
          <br />

          <h4>{{ "Prop19.BaseYearatleast55" | translate }}</h4>
          <table>
            <tbody>
              <tr>
                <th></th>
                <th class="header">
                <br>
                  <strong>{{ "Prop19.Prop60" | translate }}</strong>

                  <p>({{ "Prop19.Effectivebeforeapril" | translate }})</p>
                </th>
                <th class="header">
                <br>
                  <strong>{{ "Prop19.Prop19Caps" | translate }}</strong>

                  <p>({{ "Prop19.Effectiveasofapril" | translate }})</p>
                </th>
              </tr>
              <tr>
                <th>{{ "Prop19.Typeofprop" | translate }}</th>
                <td colspan="2">{{ "Prop19.PrincipalResidence" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.Timing" | translate }}</th>
                <td colspan="2">
                  {{ "Prop19.Purchaseofnewly" | translate }}
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.Locationof" | translate }}</th>
                <td>
                  <ul>
                    <li>{{ "Prop19.SameCounty" | translate }}</li>
                    <li>{{ "Prop19.Countywithinter" | translate }}</li>
                  </ul>
                </td>
                <td>{{ "Prop19.AnywhereinCali" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.Valuelimit" | translate }}</th>
                <td>
                  <ul>
                    <li>
                      {{ "Prop19.Equalorlesser" | translate }}
                      <ul>
                        <li>
                          {{ "Prop19.100percentprior" | translate }}
                        </li>
                        <li>
                          {{ "Prop19.105percent1styear" | translate }}
                        </li>
                        <li>
                          {{ "Prop19.110percent2ndyear" | translate }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>{{ "Prop19.AnyValue" | translate }}</li>
                    <li class="">
                      {{ "Prop19.Amountabove" | translate }}
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.Howmany" | translate }}</th>
                <td>
                  <ul>
                    <li>{{ "Prop19.Onetime" | translate }}</li>
                    <li>
                      {{ "Prop19.Exceptionafter" | translate }}
                    </li>
                  </ul>
                </td>
                <td>{{ "Prop19.Threetimes" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.ImplementingStatute" | translate }}</th>
                <td>
                  {{ "Prop19.Revenuetaxation60" | translate }}
                </td>
                <td>{{ "Prop19.Tobedetermined" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.ImportantDates" | translate }}</th>
                <td>{{ "Prop19.Throughmarch" | translate }}</td>
                <td>{{ "Prop19.EffectiveApril" | translate }}</td>
              </tr>
            </tbody>
          </table>
          <br />

          <h4>{{ "Prop19.Baseyearintracountydisaster" | translate }}</h4>
          <table>
            <tbody>
              <tr>
                <th></th>
                <th class="header">
                <br>
                  <strong>{{ "Prop19.Prop50caps" | translate }}</strong>

                  <p>({{ "Prop19.Effectivebeforeapril" | translate }})</p>
                </th>
                <th class="header">
                <br>
                  <strong>{{ "Prop19.Prop19Caps" | translate }}</strong>

                  <p>({{ "Prop19.Effectiveasofapril" | translate }})</p>
                </th>
              </tr>
              <tr>
                <th>{{ "Prop19.Typeofprop" | translate }}</th>
                <td>{{ "Prop19.Anytypeof" | translate }}</td>
                <td>{{ "Prop19.PrincipalResidence" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.Timing" | translate }}</th>
                <td>
                  {{ "Prop19.Purchasewithin5years" | translate }}
                </td>
                <td>
                  {{ "Prop19.Purchasewithin2years" | translate }}
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.Locationreplacement" | translate }}</th>
                <td>{{ "Prop19.SameCounty" | translate }}</td>
                <td>{{ "Prop19.AnywhereinCali" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.Valuelimit" | translate }}</th>
                <td>
                  <ul>
                    <li>{{ "Prop19.AnyValue" | translate }}</li>
                    <li>{{ "Prop19.Amountabove120" | translate }}</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>{{ "Prop19.AnyValue" | translate }}</li>
                    <li>{{ "Prop19.Amountabove100" | translate }}</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.Typeofdisaster" | translate }}</th>
                <td>
                  {{ "Prop19.DisasterGovernorproclaims" | translate }}
                </td>
                <td>
                  {{ "Prop19.Wildfire" | translate }}
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.ImplementingStatute" | translate }}</th>
                <td>
                  {{ "Prop19.Revenuetaxation50" | translate }}
                </td>
                <td>{{ "Prop19.Tobedetermined" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.ImportantDates" | translate }}</th>
                <td>{{ "Prop19.Throughmarch" | translate }}</td>
                <td>{{ "Prop19.EffectiveApril" | translate }}</td>
              </tr>
            </tbody>
          </table>
          <br />

          <h4>{{ "Prop19.Baseyearintercountydisaster" | translate }}</h4>
          <table>
            <tbody>
              <tr>
                <th></th>
                <th class="header">
                <br>
                  <strong>{{ "Prop19.Prop171caps" | translate }}</strong>

                  <p>({{ "Prop19.Effectivebeforeapril" | translate }})</p>
                </th>
                <th class="header">
                <br>
                  <strong>{{ "Prop19.Prop19Caps" | translate }}</strong>

                  <p>({{ "Prop19.Effectiveasofapril" | translate }})</p>
                </th>
              </tr>
              <tr>
                <th>{{ "Prop19.Typeofprop" | translate }}</th>
                <td>{{ "Prop19.PrincipalResidence" | translate }}</td>
                <td>{{ "Prop19.PrincipalResidence" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.Timing" | translate }}</th>
                <td>
                  {{ "Prop19.Purchasewithin3years" | translate }}
                </td>
                <td>
                  {{ "Prop19.Purchasewithin2years" | translate }}
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.Locationreplacement" | translate }}</th>
                <td>{{ "Prop19.Countywithintercounty13" | translate }}</td>
                <td>{{ "Prop19.AnywhereinCali" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.Valuelimit" | translate }}</th>
                <td>
                  <ul>
                    <li>
                      {{ "Prop19.Equalorlesser" | translate }}
                      <ul>
                        <li>
                          {{ "Prop19.105ifpurchased" | translate }}
                        </li>
                        <li>
                          1{{ "Prop19.110ifpurchased" | translate }}
                        </li>
                        <li>
                          {{ "Prop19.115ifpurchased" | translate }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>{{ "Prop19.AnyValue" | translate }}</li>
                    <li>{{ "Prop19.Amountabove100" | translate }}</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.Typeofdisaster" | translate }}</th>
                <td>
                  {{ "Prop19.DisasterGovernorproclaims" | translate }}
                </td>
                <td>
                  {{ "Prop19.Wildfire" | translate }}
                </td>
              </tr>
              <tr>
                <th>{{ "Prop19.ImplementingStatute" | translate }}</th>
                <td>
                  {{ "Prop19.Revenuetaxation171" | translate }}
                </td>
                <td>{{ "Prop19.Tobedetermined" | translate }}</td>
              </tr>
              <tr>
                <th>{{ "Prop19.ImportantDates" | translate }}</th>
                <td>{{ "Prop19.Throughmarch" | translate }}</td>
                <td>{{ "Prop19.EffectiveApril" | translate }}</td>
              </tr>
            </tbody>
          </table>
        </accordion-group>
      </accordion>
    </div>
    <br />

    <h4>{{ "Prop19.parent-childtransfers" | translate }}</h4>
    <p>
      <a
        href="https://www.boe.ca.gov/proptaxes/faqs/propositions58.htm"
        target="_blank"
        >{{ "Prop19.Prop58prop193" | translate }}</a
      >{{ "Prop19.allowed" | translate }}
    </p>
    <p>
      {{ "Prop19.Prop58prop193" | translate }}
      {{ "Prop19.alsoallowed" | translate }}
    </p>

    <b>{{ "Prop19.underprop19v2" | translate }}</b>
    <br><br>
    <ol>
      <li>{{ "Prop19.condition1" | translate }}</li>
      <li>{{ "Prop19.condition2v3pt1" | translate }} <a *ngIf="toggle" [routerLink]="['../homeowner-exemption']">{{ "Prop19.condition2v3pt2" | translate }}</a> <a *ngIf="!toggle" [routerLink]="['../apply-for-hox']">{{ "Prop19.condition2v3pt2" | translate }}</a> {{ "Prop19.condition2v3pt3" | translate }}</li>
      <li>{{ "Prop19.condition3" | translate }}</li>
    </ol>
    <p>
      <b>{{ "Prop19.theprovisions" | translate }}</b>
    </p>

    <h4>{{ "Prop19.Senior" | translate }}</h4>
    <p [innerHTML]=" 'Prop19.Proposition60' | translate ">
    <!--
      <a
        href="https://www.boe.ca.gov/proptaxes/prop60-90_55over.htm"
        target="_blank"
        >{{ "Prop19.Proposition60" | translate }}</a
      >{{ "Prop19.and" | translate
      }}<a
        href="https://www.boe.ca.gov/proptaxes/faqs/propositions110.htm#:~:text=Proposition%20110%20is%20a%20constitutional,and%20buy%20or%20build%20another."
        target="_blank"
        >110</a>
      {{ "Prop19.allowedpersons" | translate }}-->
    </p>
    <p>
      <i>{{ "Prop19.subjectto" | translate }}</i>
    </p>

    <p>
      <b>{{ "Prop19.theeffective" | translate }}</b>
    </p>

    <h4>{{ "Prop19.DisasterRelief" | translate }}</h4>
    <p>
      <a
        href="https://www.boe.ca.gov/proptaxes/disaster-relief.htm#Description"
        target="_blank"
        >{{ "Prop19.Prop50" | translate }}</a
      >
      {{ "Prop19.provided" | translate }}
    </p>

    <p>
      <b>{{ "Prop19.theeffective" | translate }}</b>
    </p>
  </div>
  <div class="Calculator">
    <div id="parent-child">
      <div class="calculator-top">
        <h5>{{ "Prop19.ParentChildCalculator" | translate }}</h5>
        <p [innerHTML]="'Prop19.ParentCalculatorDescription' | translate"></p>
        <button
          (click)="parentSelector = true; calc1Values = null"
          type="button"
          class="btn btn-ain"
          [ngClass]="parentSelector ? 'btn-active' : ''"
        >
          AIN <i class="fas fa-chevron-down"></i>
        </button>
        <button
          (click)="parentSelector = false; calc1Values = null"
          type="button"
          class="btn btn-address"
          [ngClass]="parentSelector ? '' : 'btn-active'"
        >
          ADDRESS <i class="fas fa-chevron-down"></i>
        </button>
      </div>
      <div class="calculator-bottom">
        <div *ngIf="parentSelector" class="select-ain animate slideIn">
          <h5>AIN ({{ "ContactAssessor.Ain" | translate }})</h5>
          <form #myForm="ngForm" (ngSubmit)="submitAin()">
            <div class="form-inline" style="display: flex; align-items: center;">
              <input
                class="form-control"
                type="text"
                [(ngModel)]="ain"
                name="ain"
                appAinMask
                placeholder="XXXX-XXX-XXX"
              />
              <button type="submit" class="btn btn-active" style="margin-left: 8px;">SEARCH</button>
            </div>
          </form>
        </div>
        <div *ngIf="!parentSelector" class="select-address animate slideIn">
          <app-ainAddress (AddressList)="getAddress($event)"></app-ainAddress>
        </div>
        <div *ngIf="calc1Values" class="parent-calculator animate slideIn">
          <hr />
          <div class="form-group" style="margin-bottom: 30px;">
            <label for="">Enter Fair Market Value</label>
            <input
              id="MarketValueParent"
              currencyMask
              [(ngModel)]="calc1Values.fairMarketValue"
              [options]="{ align: 'left', prefix: '$', precision: 0 }"
              class="form-control"
            />
          </div>
          <div
            *ngIf="calc1Values.fairMarketValue != 0"
            class="upper animate slideIn"
          >
            <label style="margin: 10px 0px 10px 0px;"
              >1. {{ "Prop19.CalcTaxSum" | translate }}
              {{ calc1Values.millionDollarExclusion }}</label
            >
            <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px;">
              <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                <input
                  currencyMask
                  [options]="{ align: 'left', prefix: '$', precision: 0 }"
                  [(ngModel)]="calc1Values.taxableValue"
                  class="form-control"
                  disabled
                  style="width: 100%; height: 40px; text-align: center;"
                />
                <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">TAXABLE VALUE</p>
              </div>

              <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                <p><i class="fas fa-plus"></i></p>
              </div>

              <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                <input
                  currencyMask
                  [options]="{ align: 'left', prefix: '$', precision: 0 }"
                  [(ngModel)]="calc1Values.millionDollarExclusion"
                  class="form-control"
                  disabled
                  style="width: 100%; height: 40px; text-align: center;"
                />
                <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">EXCLUSION ADJUSTED ANNUALLY</p>
              </div>

              <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                <p><i class="fas fa-equals"></i></p>
              </div>

              <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                <input
                  currencyMask
                  [options]="{ align: 'left', prefix: '$', precision: 0 }"
                  [ngModel]="calc1Values.millionDollarExclusion + calc1Values.taxableValue"
                  class="form-control"
                  disabled
                  style="width: 100%; height: 40px; text-align: center;"
                />
                <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">SUM</p>
              </div>
            </div>
            <label style="margin: 20px 0px 10px 0px;"
              >2. {{ "Prop19.CalcTaxSum" | translate }}
              {{ calc1Values.millionDollarExclusion }}</label
            >
            <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px;">
              <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                <input
                  currencyMask
                  [options]="{ align: 'left', prefix: '$', precision: 0 }"
                  [ngModel]="calc1Values.fairMarketValue"
                  class="form-control border-blue"
                  disabled
                  style="width: 100%; height: 40px; text-align: center;"
                />
                <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">FAIR MARKET VALUE</p>
              </div>

              <div *ngIf="checkValue()" class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                <p><i class="fas fa-less-than-equal"></i></p>
              </div>
              <div *ngIf="!checkValue()" class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                <p><i class="fas fa-greater-than"></i></p>
              </div>

              <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                <input
                  currencyMask
                  [options]="{ align: 'left', prefix: '$', precision: 0 }"
                  [ngModel]="calc1Values.millionDollarExclusion + calc1Values.taxableValue"
                  class="form-control"
                  disabled
                  style="width: 100%; height: 40px; text-align: center;"
                />
                <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">EXCLUSION ADJUSTED ANNUALLY</p>
              </div>
            </div>
            <div *ngIf="checkValue()">
              <p
                style="text-align: left; color: blue"
                [innerHTML]="'Prop19.FmvAlertNo' | translate"
              ></p>
              <label style="margin: 20px 0px 10px 0px;">3. {{ "Prop19.Retained" | translate }}</label>
              <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px;">
                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc1Values.taxableValue"
                    class="form-control border-green"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">TAXABLE VALUE</p>
                </div>
              </div>
            </div>
            <div *ngIf="!checkValue()">
              <p
                style="text-align: left; color: blue"
                [innerHTML]="'Prop19.FmvAlertYes' | translate"
              ></p>
              <label style="margin: 20px 0px 10px 0px;">3. {{ "Prop19.Difference" | translate }}</label>
              <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px;">
                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc1Values.fairMarketValue"
                    class="form-control"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">FAIR MARKET VALUE</p>
                </div>

                <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                  <p><i class="fas fa-minus"></i></p>
                </div>

                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc1Values.millionDollarExclusion + calc1Values.taxableValue"
                    class="form-control"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">SUM</p>
                </div>

                <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                  <p><i class="fas fa-equals"></i></p>
                </div>

                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc1Values.fairMarketValue - (calc1Values.millionDollarExclusion + calc1Values.taxableValue)"
                    class="form-control"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">DIFFERENCE</p>
                </div>
              </div>
              <label style="margin: 20px 0px 10px 0px;">3. {{ "Prop19.Add" | translate }}</label>
              <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px;">
                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc1Values.fairMarketValue - (calc1Values.millionDollarExclusion + calc1Values.taxableValue)"
                    class="form-control"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">DIFFERENCE</p>
                </div>

                <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                  <p><i class="fas fa-plus"></i></p>
                </div>

                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc1Values.taxableValue"
                    class="form-control"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">TAXABLE VALUE</p>
                </div>

                <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                  <p><i class="fas fa-equals"></i></p>
                </div>

                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc1Values.fairMarketValue - (calc1Values.millionDollarExclusion + calc1Values.taxableValue) + calc1Values.taxableValue"
                    class="form-control border-green"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">FINAL VALUE</p>
                </div>
              </div>
            </div>
          </div>
          <button class="btn" style="margin-top: 10px;" (click)="calc1Values = null">Clear</button>
        </div>
      </div>
    </div>
    <div id="base-year">
      <div class="calculator-top">
        <h5>{{ "Prop19.BaseYearCalculator" | translate }}</h5>
        <p [innerHTML]="'Prop19.BaseYearDescription' | translate"></p>
        <button
          (click)="baseYearSelector = true; calc2Values = null"
          type="button"
          class="btn btn-ain"
          [ngClass]="baseYearSelector ? 'btn-active' : ''"
        >
          AIN <i class="fas fa-chevron-down"></i>
        </button>
        <button
          (click)="baseYearSelector = false; calc2Values = null"
          type="button"
          class="btn btn-address"
          [ngClass]="baseYearSelector ? '' : 'btn-active'"
        >
          ADDRESS <i class="fas fa-chevron-down"></i>
        </button>
      </div>
      <div class="calculator-bottom">
        <div *ngIf="baseYearSelector" class="select-ain animate slideIn">
          <h5>AIN ({{ "ContactAssessor.Ain" | translate }})</h5>
          <form #ainF="ngForm" (ngSubmit)="submitAin('base')">
            <div class="form-inline" style="display: flex; align-items: center;">
              <input
                class="form-control"
                type="text"
                [(ngModel)]="ain"
                name="ain"
                appAinMask
                placeholder="XXXX-XXX-XXX"
              />
              <button type="submit" class="btn btn-active" style="margin-left: 8px;">SEARCH</button>
            </div>
          </form>
        </div>
        <div *ngIf="!baseYearSelector" class="select-address animate slideIn">
          <app-ainAddress
            (AddressList)="getAddress($event, 'base')"
          ></app-ainAddress>
        </div>
        <div *ngIf="calc2Values" class="parent-calculator animate slideIn">
          <hr />
          <div class="form-group">
            <label for=""
              >Enter Fair Market Value of Original Principal Residence</label
            >
            <input
              id="MarketValueBaseYear"
              currencyMask
              [(ngModel)]="calc2Values.fairMarketValue"
              [options]="{ align: 'left', prefix: '$', precision: 0 }"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for=""
              >Enter Fair Market Value of Replacement Principal Residence</label
            >
            <input
              currencyMask
              [(ngModel)]="calc2Values.fairMarketValueReplacement"
              [options]="{ align: 'left', prefix: '$', precision: 0 }"
              class="form-control"
            />
          </div>
          <div
            *ngIf="
              calc2Values.fairMarketValue > 0 &&
              calc2Values.fairMarketValueReplacement > 0
            "
            class="upper animate slideIn"
          >
            <div *ngIf="checkParentValue()">
              <label style="margin: 20px 0px 10px 0px;">3. {{ "Prop19.FmvDifference" | translate }}</label>
              <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px;">
                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc2Values.fairMarketValueReplacement"
                    class="form-control border-blue"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">FMV Replacement Property</p>
                </div>

                <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                  <p><i class="fas fa-minus"></i></p>
                </div>

                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc2Values.fairMarketValue"
                    class="form-control border-blue"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">FMV Original Property</p>
                </div>

                <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                  <p><i class="fas fa-equals"></i></p>
                </div>

                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc2Values.fairMarketValueReplacement - calc2Values.fairMarketValue"
                    class="form-control"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">Positive DIFFERENCE</p>
                </div>
              </div>
              <label style="margin: 20px 0px 10px 0px;">3. {{ "Prop19.FmvAdd" | translate }}</label>
              <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px;">
                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc2Values.fairMarketValueReplacement - calc2Values.fairMarketValue"
                    class="form-control"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">DIFFERENCE</p>
                </div>

                <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                  <p><i class="fas fa-plus"></i></p>
                </div>

                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc2Values.taxableValue"
                    class="form-control"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">TAXABLE VALUE of Original Principal Residence</p>
                </div>

                <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                  <p><i class="fas fa-equals"></i></p>
                </div>

                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 25%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc2Values.fairMarketValueReplacement - calc2Values.fairMarketValue + calc2Values.taxableValue"
                    class="form-control border-green"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                </div>
              </div>
            </div>
            <div *ngIf="!checkParentValue()">
              <label style="margin: 20px 0px 10px 0px;">1. {{ "Prop19.NoPositive" | translate }}</label>
              <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px;">
                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 45%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc2Values.taxableValue"
                    class="form-control"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">TAXABLE VALUE of Original Principal Residence</p>
                </div>

                <div class="col-md-1 text-center" style="display: flex; flex-direction: column; justify-content: center; width: 40px;">
                  <p><i class="fas fa-equals"></i></p>
                </div>

                <div class="col-md-3 form-group" style="display: flex; flex-direction: column; align-items: center; width: 45%;">
                  <input
                    currencyMask
                    [options]="{ align: 'left', prefix: '$', precision: 0 }"
                    [ngModel]="calc2Values.taxableValue"
                    class="form-control border-green"
                    disabled
                    style="width: 100%; height: 40px; text-align: center;"
                  />
                  <p class="text-center" style="min-height: 40px; text-align: center; white-space: nowrap;">NEW BASE YEAR VALUE FOR REPLACEMENT RESIDENCE (full benefit)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-videos-grid class="Videos" [videos]="videos"></app-videos-grid>
  <div class="news">
    <div class="General pt-4">
      <div class="General container-fluid">

        <div class="row NewsItems">

          <div *ngFor="let item of newsRecent" class="col-md-6 col-lg-4 d-flex alight-items-stretch mb-4">
            <a href="{{item.linkUrl}}" target="_blank" class="card grow">
              <img class="card-img-top" src="{{item.imageUrl}}" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title">{{item.title}}</h5>
                <p class="card-date">{{item.newsDate | date}}</p>
                <p class="card-text">{{item.description}}</p>

              </div>
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</app-leveltwo>
